import { render } from "./ZhaiTwoTuttonsPC.vue?vue&type=template&id=1fc4badb&scoped=true"
import script from "./ZhaiTwoTuttonsPC.vue?vue&type=script&lang=js"
export * from "./ZhaiTwoTuttonsPC.vue?vue&type=script&lang=js"

import "./ZhaiTwoTuttonsPC.vue?vue&type=style&index=0&id=1fc4badb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fc4badb"]])

export default __exports__